export enum FlashMessagesNotificationTypes {
  SHOW_REQUEST = '@flash_messages_notification/SHOW_REQUEST',
  SHOW_SUCCESS = '@flash_messages_notification/SHOW_SUCCESS',
  SHOW_FAILURE = '@flash_messages_notification/SHOW_FAILURE',
  SHOW_FEEDBACK = '@flash_messages_notification/SHOW_FEEDBACK',
  READ_FEEDBACK = '@flash_messages_notification/READ_FEEDBACK',
}

export interface FlashMessagesNotificationData {
  text: string;
  expired: boolean;
  url: string;
  show: boolean;
  boleto_receita_id?: number | null;
}

export interface RequestState {
  loading: boolean;
  loaded: boolean;
  error: boolean;
}

export interface FeedbackNotificationData {
  text: string;
  class: string;
  show: boolean;
}

export interface FlashMessagesNotificationState {
  readonly flash_messages_notification: FlashMessagesNotificationData;
  readonly feedback_notification: FeedbackNotificationData;
  readonly request: RequestState;
}
